import React, { Component } from 'react';
import { connect } from 'react-redux';

import User from '../../../models/User';

import OrdersHeader from './OrdersHeader';

interface OrdersHeaderContainerProps {
  type: 'po' | 'do';
  orderNumber: string;
  user: User;
};

interface OrdersHeaderContainerState {
};

class OrdersHeaderContainer extends Component<OrdersHeaderContainerProps,  OrdersHeaderContainerState> {


  render() {
  
    return (
      <OrdersHeader 
        type={ this.props.type }
        orderNumber={ this.props.orderNumber }
        forwarder={ this.props.user }
      />
    )
  }  

}

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(OrdersHeaderContainer);